module.exports = __webpack_public_path__ + "static/media/zeplin.c160c891.png";